<template>
  <router-view />
</template>
<script>
  export default {
    name: 'AdministradorModule',
  }
</script>
